import {
  faArrowsH,
  faBars,
  faCircleExclamation,
  faCube,
  faCutlery,
  faFlask,
  faParking,
  faSnowflake,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './SymbolKey.scss';
import PropTypes from 'prop-types';

// General SymbolKey Component
const SymbolKey = ({ type }) => {
  return (
    <div className={`symbol_key_container ${type}`}>
      <div className="key_item">
        <div className="key_item_symbol hazardous">
          <FontAwesomeIcon icon={faFlask} data-testid="hazard_icon" />
        </div>
        Hazardous Cargo
      </div>
      {type == 'arrivals' ? (
        <div className="key_item">
          <div className="key_item_symbol prioritise">
            <FontAwesomeIcon icon={faParking} data-testid="prioritise_icon" />
          </div>
          Prioritise
        </div>
      ) : (
        <>
          <div className="key_item">
            <div className="key_item_symbol must_load">
              <FontAwesomeIcon icon={faCircleExclamation} data-testid="must_load_icon" />
            </div>
            Must Load
          </div>
          <div className="key_item">
            <div className="key_item_symbol full_load">
              <FontAwesomeIcon icon={faCube} data-testid="full_load_icon" />
            </div>
            Full Load
          </div>
        </>
      )}
      <div className="key_item">
        <div className="key_item_symbol do_not_stack">
          <FontAwesomeIcon icon={faBars} data-testid="do_not_stack_icon" />
        </div>
        Do Not Stack
      </div>
      <div className="key_item">
        <div className="key_item_symbol waste">
          <FontAwesomeIcon icon={faTrash} data-testid="waste_icon" />
        </div>
        Waste
      </div>
      <div className="key_item">
        <div className="key_item_symbol foodstuffs">
          <FontAwesomeIcon icon={faCutlery} data-testid="foodstuffs_icon" />
        </div>
        Foodstuffs
      </div>
      <div className="key_item">
        <div className="key_item_symbol temp_control">
          <FontAwesomeIcon icon={faSnowflake} data-testid="temperature_icon" />
        </div>
        Temperature Controlled
      </div>

      <div className="key_item">
        <div className="key_item_symbol overlength">
          <FontAwesomeIcon icon={faArrowsH} data-testid="overlength_icon" />
        </div>
        Overlength
      </div>
    </div>
  );
};

SymbolKey.propTypes = {
  type: PropTypes.string,
};

export default SymbolKey;
